import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.survey.renderer');
import { Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-survey-renderer',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.survey.renderer/view.scss */
@charset "UTF-8";
:host {
  display: block;
  width: 100%;
}

.question-shell {
  display: grid;
  gap: 1rem;
  padding: 1.1rem 1.15rem;
  border-radius: 1.5rem;
  border: 1px solid rgba(191, 208, 255, 0.55);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(247, 250, 255, 0.92) 100%);
  box-shadow: 0 18px 42px rgba(64, 86, 147, 0.08);
}

.question-shell__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.question-shell__titlewrap {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  min-width: 0;
}

.question-shell__number {
  flex: 0 0 auto;
  min-width: 2.4rem;
  padding: 0.32rem 0.6rem;
  border-radius: 999px;
  background: linear-gradient(135deg, #e0e7ff 0%, #f2f5ff 100%);
  color: #4f46e5;
  font-size: 0.75rem;
  font-weight: 800;
  text-align: center;
}

.question-shell__titlebox {
  min-width: 0;
}

.question-shell__title {
  color: #172554;
  font-size: 1rem;
  line-height: 1.65;
  font-weight: 700;
  white-space: pre-line;
}

.question-shell__desc {
  margin-top: 0.35rem;
  color: #64748b;
  font-size: 0.82rem;
  line-height: 1.55;
}

.question-shell__required {
  flex: 0 0 auto;
  padding: 0.32rem 0.65rem;
  border-radius: 999px;
  background: rgba(251, 113, 133, 0.12);
  color: #e11d48;
  font-size: 0.74rem;
  font-weight: 700;
}

.choice-group {
  display: grid;
  gap: 0.72rem;
}

.choice-card,
.binary-choice__card,
.choice-chip,
.likert-band__option {
  position: relative;
  cursor: pointer;
  transition: transform 180ms ease, border-color 180ms ease, background 180ms ease, box-shadow 180ms ease, color 180ms ease;
}

.choice-card input,
.binary-choice__card input,
.choice-chip input,
.likert-band__option input,
.matrix-table__cell input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.choice-card {
  display: flex;
  align-items: flex-start;
  gap: 0.82rem;
  padding: 0.95rem 1rem;
  border-radius: 1.15rem;
  border: 1px solid rgba(203, 213, 225, 0.95);
  background: rgba(255, 255, 255, 0.95);
}

.choice-card:hover,
.binary-choice__card:hover,
.choice-chip:hover,
.likert-band__option:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(99, 102, 241, 0.1);
}

.choice-card.is-selected {
  border-color: rgba(99, 102, 241, 0.62);
  background: linear-gradient(180deg, rgba(238, 242, 255, 0.95) 0%, rgb(255, 255, 255) 100%);
  box-shadow: 0 18px 36px rgba(99, 102, 241, 0.14);
}

.choice-card__mark {
  flex: 0 0 auto;
  width: 1.15rem;
  height: 1.15rem;
  margin-top: 0.18rem;
  border-radius: 999px;
  border: 1.5px solid #cbd5e1;
  background: #fff;
}

.choice-card--checkbox .choice-card__mark {
  border-radius: 0.45rem;
}

.choice-card.is-selected .choice-card__mark {
  border-color: #4f46e5;
  background: radial-gradient(circle at center, #4f46e5 0 43%, #ffffff 44% 100%);
}

.choice-card--checkbox.is-selected .choice-card__mark {
  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
  border-color: #4f46e5;
  box-shadow: inset 0 0 0 2px #fff;
}

.choice-card__label {
  color: #334155;
  font-size: 0.94rem;
  line-height: 1.55;
  font-weight: 600;
}

.choice-group--image,
.choice-group--color {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.choice-card--visual {
  display: grid;
  gap: 0.72rem;
  min-height: 100%;
  padding: 0.82rem;
}

.choice-card--visual .choice-card__mark {
  display: none;
}

.choice-card__select-badge {
  position: absolute;
  top: 0.65rem;
  right: 0.65rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.45rem;
  height: 1.45rem;
  border-radius: 999px;
  z-index: 3;
  background: #2563eb;
  color: #fff;
  border: 1px solid rgba(29, 78, 216, 0.95);
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.28);
  font-size: 0.88rem;
  font-weight: 900;
  line-height: 1;
  text-shadow: 0 0 0 #fff, 0.02em 0 0 #fff, -0.02em 0 0 #fff, 0 0.02em 0 #fff, 0 -0.02em 0 #fff;
  opacity: 0;
  transform: scale(0.86);
  transition: opacity 180ms ease, transform 180ms ease;
}

.choice-card.is-selected .choice-card__select-badge {
  opacity: 1;
  transform: scale(1);
}

.choice-card__media {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 5.8rem;
  padding: 0.5rem;
  border-radius: 1rem;
  background: linear-gradient(180deg, rgba(248, 250, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%);
  border: 1px solid rgba(226, 232, 240, 0.95);
}

.choice-card__image {
  width: 100%;
  max-width: 8rem;
  height: 4.8rem;
  object-fit: contain;
}

.choice-card--image {
  align-content: start;
  justify-items: stretch;
  text-align: center;
}

.choice-card--image .choice-card__label {
  text-align: center;
  font-size: 0.84rem;
  line-height: 1.5;
}

.choice-card--color {
  display: block;
  padding: 0.72rem;
  background: transparent;
}

.choice-card__swatch {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 1.75/1;
  border-radius: 1rem;
  border: none;
  background-image: none;
  box-shadow: none;
  overflow: hidden;
}

.choice-card__swatch--transparent {
  background-color: transparent !important;
  border: 1px solid rgba(203, 213, 225, 0.9);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8), inset 0 0 0 999px rgba(255, 255, 255, 0.18);
}

.choice-card__swatch--transparent::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.34) 0%, rgba(255, 255, 255, 0.08) 100%);
  pointer-events: none;
}

.choice-card__swatch-label {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(100, 116, 139, 0.46);
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.45);
}

.choice-card--color:hover {
  transform: none;
  box-shadow: none;
}

.choice-card--color.is-selected {
  background: transparent;
  box-shadow: none;
}

.choice-card--color.is-selected .choice-card__swatch {
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.2);
}

.binary-choice {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
}

.binary-choice__card {
  display: grid;
  place-items: center;
  min-height: 4.1rem;
  padding: 1rem;
  border-radius: 1.2rem;
  border: 1px solid rgba(203, 213, 225, 0.95);
  background: rgba(255, 255, 255, 0.96);
  text-align: center;
}

.binary-choice__card.is-selected {
  border-color: rgba(79, 70, 229, 0.72);
  background: linear-gradient(180deg, rgba(224, 231, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%);
  box-shadow: 0 18px 34px rgba(79, 70, 229, 0.16);
}

.binary-choice__card.is-selected::after {
  content: "✓";
  position: absolute;
  top: 0.72rem;
  right: 0.78rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.3rem;
  height: 1.3rem;
  border-radius: 999px;
  background: #4f46e5;
  color: #fff;
  font-size: 0.78rem;
  font-weight: 900;
}

.binary-choice__icon {
  color: #334155;
  font-size: 1rem;
  font-weight: 800;
}

.binary-choice__card.is-selected .binary-choice__icon {
  color: #312e81;
}

.likert-band {
  display: grid;
  gap: 0.85rem;
  padding: 1rem;
  border-radius: 1.35rem;
  background: linear-gradient(180deg, rgba(245, 247, 255, 0.95) 0%, rgba(255, 255, 255, 0.98) 100%);
  border: 1px solid rgba(206, 215, 255, 0.9);
}

.likert-band__anchors {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  color: #64748b;
  font-size: 0.76rem;
  line-height: 1.45;
  font-weight: 700;
}

.likert-band__anchors span:first-child {
  max-width: 46%;
}

.likert-band__anchors span:last-child {
  max-width: 46%;
  text-align: right;
}

.likert-band__buttons {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0.5rem;
}

.likert-band__option {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 3.2rem;
  border-radius: 1rem;
  border: 1px solid rgba(203, 213, 225, 0.95);
  background: rgba(255, 255, 255, 0.96);
}

.likert-band__option.is-selected {
  border-color: rgba(79, 70, 229, 0.62);
  background: linear-gradient(180deg, rgba(224, 231, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%);
  box-shadow: 0 18px 32px rgba(79, 70, 229, 0.16);
}

.likert-band__index {
  color: #1e293b;
  font-size: 1rem;
  font-weight: 800;
}

.likert-band__current {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.78rem 0.9rem;
  border-radius: 1rem;
  background: rgba(79, 70, 229, 0.08);
}

.likert-band__current-label {
  color: #6366f1;
  font-size: 0.78rem;
  font-weight: 700;
}

.likert-band__current-value {
  color: #312e81;
  font-size: 0.88rem;
  font-weight: 800;
  text-align: right;
}

.input-row,
.time-grid {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  flex-wrap: wrap;
}

.time-picker {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.72rem;
}

.time-picker__field {
  display: grid;
  gap: 0.42rem;
  min-width: 0;
}

.time-picker__label {
  color: #64748b;
  font-size: 0.74rem;
  font-weight: 800;
  letter-spacing: 0.03em;
  padding-left: 0.1rem;
}

.time-picker__select {
  width: 100%;
  min-width: 0;
  padding-right: 2.4rem;
  appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, #64748b 50%), linear-gradient(135deg, #64748b 50%, transparent 50%);
  background-position: calc(100% - 1.1rem) calc(50% - 0.14rem), calc(100% - 0.8rem) calc(50% - 0.14rem);
  background-size: 0.38rem 0.38rem, 0.38rem 0.38rem;
  background-repeat: no-repeat;
}

.input-row__unit {
  color: #64748b;
  font-size: 0.84rem;
  font-weight: 700;
}

.input-row__prefix {
  color: #64748b;
  font-size: 0.84rem;
  font-weight: 800;
}

.soft-input,
.soft-select,
.soft-textarea {
  width: 100%;
  border-radius: 1rem;
  border: 1px solid rgba(203, 213, 225, 0.95);
  background: rgba(255, 255, 255, 0.98);
  color: #0f172a;
  font-size: 0.93rem;
  font-weight: 600;
  padding: 0.85rem 0.95rem;
  outline: none;
  transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;
}

.soft-input:focus,
.soft-select:focus,
.soft-textarea:focus {
  border-color: rgba(79, 70, 229, 0.56);
  box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1);
}

.soft-input--compact {
  width: 7rem;
}

.soft-textarea {
  min-height: 7.4rem;
  resize: vertical;
}

.chip-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;
}

.choice-chip {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 3.1rem;
  padding: 0.75rem 0.9rem;
  border-radius: 999px;
  border: 1px solid rgba(203, 213, 225, 0.95);
  background: rgba(255, 255, 255, 0.95);
  color: #334155;
  font-size: 0.86rem;
  font-weight: 700;
  text-align: center;
}

.choice-chip.is-selected {
  border-color: rgba(79, 70, 229, 0.65);
  background: linear-gradient(180deg, rgb(224, 231, 255) 0%, rgb(255, 255, 255) 100%);
  color: #312e81;
}

.matrix-stack {
  display: grid;
  gap: 0.9rem;
}

.matrix-card {
  display: grid;
  gap: 0.72rem;
  padding: 0.95rem;
  border-radius: 1.2rem;
  border: 1px solid rgba(203, 213, 225, 0.92);
  background: linear-gradient(180deg, rgba(248, 250, 255, 0.98) 0%, rgba(255, 255, 255, 0.99) 100%);
}

.matrix-card__title {
  color: #334155;
  font-size: 0.88rem;
  line-height: 1.55;
  font-weight: 800;
}

.matrix-card__options {
  display: grid;
  gap: 0.55rem;
}

.matrix-choice {
  min-height: 3rem;
  padding: 0.75rem 0.82rem;
}

.matrix-choice__label {
  font-size: 0.84rem;
  line-height: 1.45;
}

.matrix-followups {
  display: grid;
  gap: 0.9rem;
}

.matrix-followup {
  display: grid;
  gap: 0.75rem;
  padding: 1rem;
  border-radius: 1.2rem;
  border: 1px solid rgba(203, 213, 225, 0.92);
  background: rgba(255, 255, 255, 0.94);
}

.matrix-followup__head {
  display: flex;
  align-items: flex-start;
  gap: 0.7rem;
}

.question-shell__number--sub {
  min-width: 2.1rem;
  padding: 0.28rem 0.52rem;
  background: linear-gradient(135deg, #eef2ff 0%, #f8faff 100%);
}

.matrix-followup__title {
  color: #1e3a8a;
  font-size: 0.96rem;
  line-height: 1.55;
  font-weight: 700;
}

.matrix-followup__body,
.matrix-followup__choices {
  padding-left: 2.8rem;
}

@media (max-width: 767px) {
  .question-shell {
    gap: 0.78rem;
    padding: 0.88rem 0.9rem;
    border-radius: 1.18rem;
  }
  .question-shell__head {
    gap: 0.55rem;
  }
  .question-shell__titlewrap {
    gap: 0.55rem;
  }
  .question-shell__number {
    min-width: 2rem;
    padding: 0.24rem 0.48rem;
    font-size: 0.68rem;
  }
  .question-shell__title {
    font-size: 0.93rem;
    line-height: 1.52;
  }
  .question-shell__desc {
    margin-top: 0.24rem;
    font-size: 0.75rem;
    line-height: 1.5;
  }
  .question-shell__required {
    padding: 0.24rem 0.5rem;
    font-size: 0.66rem;
  }
  .choice-group {
    gap: 0.55rem;
  }
  .choice-card {
    gap: 0.65rem;
    padding: 0.78rem 0.82rem;
    border-radius: 1rem;
  }
  .choice-card__label {
    font-size: 0.86rem;
    line-height: 1.45;
  }
  .choice-card--visual {
    padding: 0.68rem;
    gap: 0.6rem;
  }
  .choice-card__media {
    min-height: 4.8rem;
    padding: 0.4rem;
  }
  .choice-card__image {
    height: 4rem;
  }
  .choice-card__swatch {
    border-radius: 0.82rem;
  }
  .binary-choice {
    gap: 0.55rem;
  }
  .binary-choice__card {
    min-height: 3.5rem;
    padding: 0.82rem;
    border-radius: 1rem;
  }
  .binary-choice__icon {
    font-size: 0.88rem;
  }
  .likert-band {
    gap: 0.7rem;
    padding: 0.8rem;
    border-radius: 1.15rem;
  }
  .likert-band__anchors {
    gap: 0.55rem;
    font-size: 0.69rem;
  }
  .likert-band__buttons {
    gap: 0.35rem;
  }
  .likert-band__option {
    min-height: 2.7rem;
    border-radius: 0.85rem;
  }
  .likert-band__index {
    font-size: 0.9rem;
  }
  .likert-band__current {
    padding: 0.66rem 0.75rem;
    border-radius: 0.9rem;
  }
  .likert-band__current-label {
    font-size: 0.72rem;
  }
  .likert-band__current-value {
    font-size: 0.8rem;
  }
  .soft-input,
  .soft-select,
  .soft-textarea {
    padding: 0.74rem 0.8rem;
    border-radius: 0.9rem;
    font-size: 0.88rem;
  }
  .soft-input--compact {
    width: 100%;
    max-width: 6.9rem;
  }
  .time-picker {
    gap: 0.55rem;
  }
  .time-picker__field {
    gap: 0.36rem;
  }
  .time-picker__label {
    font-size: 0.68rem;
  }
  .time-picker__select {
    padding-right: 2rem;
  }
  .soft-textarea {
    min-height: 6.2rem;
  }
  .chip-grid {
    gap: 0.5rem;
  }
  .choice-chip {
    min-height: 2.65rem;
    padding: 0.6rem 0.7rem;
    font-size: 0.78rem;
  }
  .matrix-table {
    min-width: 31rem;
  }
}
.field-grid {
  display: grid;
  gap: 0.85rem;
}

.drink-list {
  display: grid;
  gap: 0.95rem;
}

.drink-entry {
  position: relative;
  display: grid;
  gap: 0.8rem;
  padding: 0.95rem;
  border-radius: 1.2rem;
  border: 1px solid rgba(206, 215, 255, 0.86);
  background: linear-gradient(180deg, rgba(248, 250, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%);
}

.drink-entry__remove {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.8rem;
  height: 1.8rem;
  border: 1px solid rgba(203, 213, 225, 0.95);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.98);
  color: #64748b;
  box-shadow: 0 10px 18px rgba(15, 23, 42, 0.08);
  cursor: pointer;
  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, color 180ms ease;
}

.drink-entry__remove:hover {
  transform: translateY(-1px);
  border-color: rgba(99, 102, 241, 0.44);
  color: #4338ca;
  box-shadow: 0 12px 22px rgba(79, 70, 229, 0.12);
}

.drink-entry__remove-icon {
  font-size: 1rem;
  font-weight: 900;
  line-height: 1;
}

.drink-entry__label {
  color: #4f46e5;
  font-size: 0.8rem;
  font-weight: 800;
  padding-right: 2.2rem;
}

.drink-amount-row {
  display: grid;
  gap: 0.38rem;
}

.drink-amount-row__controls {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(5.6rem, 0.9fr);
  gap: 0.6rem;
}

.drink-amount-row__amount,
.drink-amount-row__unit {
  width: 100%;
}

.drink-frequency-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 0.45rem;
}

.drink-frequency-card {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 3rem;
  padding: 0.7rem 0.2rem;
  border-radius: 0.95rem;
  border: 1px solid rgba(203, 213, 225, 0.95);
  background: rgba(255, 255, 255, 0.96);
  color: #475569;
  cursor: pointer;
  transition: transform 180ms ease, border-color 180ms ease, box-shadow 180ms ease, background 180ms ease, color 180ms ease;
}

.drink-frequency-card:hover {
  transform: translateY(-1px);
  border-color: rgba(99, 102, 241, 0.44);
  box-shadow: 0 12px 22px rgba(99, 102, 241, 0.12);
}

.drink-frequency-card.is-selected {
  border-color: rgba(79, 70, 229, 0.72);
  background: linear-gradient(180deg, rgba(224, 231, 255, 0.98) 0%, rgb(255, 255, 255) 100%);
  box-shadow: 0 16px 28px rgba(79, 70, 229, 0.16);
  color: #312e81;
}

.drink-frequency-card:disabled {
  cursor: default;
}

.drink-frequency-card__number {
  font-size: 0.96rem;
  font-weight: 900;
  line-height: 1;
}

.drink-add-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 3rem;
  padding: 0.8rem 1rem;
  border: 1px dashed rgba(99, 102, 241, 0.46);
  border-radius: 1rem;
  background: rgba(238, 242, 255, 0.52);
  color: #4338ca;
  font-size: 0.88rem;
  font-weight: 800;
  cursor: pointer;
  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, background 180ms ease;
}

.drink-add-button:hover {
  transform: translateY(-1px);
  border-color: rgba(79, 70, 229, 0.62);
  background: rgba(224, 231, 255, 0.74);
  box-shadow: 0 14px 28px rgba(79, 70, 229, 0.12);
}

.drink-add-button__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.35rem;
  height: 1.35rem;
  border-radius: 999px;
  background: #4f46e5;
  color: #fff;
  font-size: 0.92rem;
  line-height: 1;
}

.drink-add-button__text {
  letter-spacing: -0.01em;
}

.field-grid--wide {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.field-label {
  display: block;
  margin-bottom: 0.38rem;
  color: #64748b;
  font-size: 0.78rem;
  font-weight: 800;
}

.choice-card.is-disabled,
.binary-choice__card.is-disabled,
.choice-chip.is-disabled,
.likert-band__option.is-disabled {
  cursor: default;
}

@media (min-width: 768px) {
  .choice-group {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .choice-group--image {
    grid-template-columns: repeat(auto-fit, minmax(8.75rem, 1fr));
  }
  .choice-group--color {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .matrix-card__options {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .field-grid,
  .field-grid--wide {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .chip-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 767px) {
  .question-shell {
    padding: 1rem;
    border-radius: 1.35rem;
  }
  .question-shell__head {
    flex-direction: column;
    align-items: stretch;
  }
  .question-shell__required {
    align-self: flex-start;
  }
  .likert-band__anchors {
    font-size: 0.72rem;
  }
  .drink-amount-row__controls {
    grid-template-columns: minmax(0, 1fr) minmax(4.8rem, 0.72fr);
    gap: 0.5rem;
  }
  .drink-frequency-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 0.42rem;
  }
  .drink-frequency-card {
    min-height: 2.75rem;
    border-radius: 0.82rem;
    padding: 0.6rem 0.15rem;
  }
  .drink-frequency-card__number {
    font-size: 0.9rem;
  }
  .drink-entry__remove {
    top: 0.68rem;
    right: 0.68rem;
    width: 1.72rem;
    height: 1.72rem;
  }
  .binary-choice {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .choice-group--image,
  .choice-group--color {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .soft-input--compact {
    width: 5.75rem;
  }
}
.clinical-form,
.lab-form {
  display: grid;
  gap: 1rem;
}

.clinical-block {
  display: grid;
  gap: 0.8rem;
  padding: 1rem;
  border: 1px solid rgba(203, 213, 225, 0.92);
  border-radius: 1.2rem;
  background: linear-gradient(180deg, rgba(248, 250, 255, 0.98) 0%, rgba(255, 255, 255, 0.99) 100%);
}

.clinical-block__title {
  color: #1e293b;
  font-size: 0.92rem;
  line-height: 1.5;
  font-weight: 850;
}

.clinical-subblock {
  display: grid;
  gap: 0.7rem;
  padding-top: 0.2rem;
}

.clinical-choice-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.6rem;
}

.clinical-choice-grid--compact {
  gap: 0.45rem;
}

.clinical-choice {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 3rem;
  padding: 0.7rem 0.8rem;
  border: 1px solid rgba(203, 213, 225, 0.95);
  border-radius: 0.95rem;
  background: rgba(255, 255, 255, 0.98);
  color: #475569;
  font-size: 0.84rem;
  line-height: 1.35;
  font-weight: 800;
  text-align: center;
  cursor: pointer;
  transition: border-color 180ms ease, background 180ms ease, box-shadow 180ms ease;
}

.clinical-choice input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.clinical-choice.is-selected {
  border-color: rgba(79, 70, 229, 0.7);
  background: linear-gradient(180deg, rgba(224, 231, 255, 0.98) 0%, rgb(255, 255, 255) 100%);
  color: #312e81;
  box-shadow: 0 12px 24px rgba(79, 70, 229, 0.14);
}

.clinical-choice.is-disabled {
  cursor: default;
}

.clinical-field-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.8rem;
}

.clinical-field {
  min-width: 0;
}

.clinical-field .input-row {
  flex-wrap: nowrap;
}

.clinical-field .soft-input {
  min-width: 0;
}

.lab-results {
  display: grid;
  gap: 0.75rem;
}

.lab-results__guide {
  padding: 0.8rem 0.9rem;
  border-radius: 1rem;
  background: rgba(254, 243, 199, 0.72);
  color: #92400e;
  font-size: 0.8rem;
  line-height: 1.5;
  font-weight: 750;
}

.lab-result-row {
  display: grid;
  gap: 0.8rem;
  padding: 0.95rem;
  border: 1px solid rgba(203, 213, 225, 0.92);
  border-radius: 1.15rem;
  background: rgba(255, 255, 255, 0.98);
}

.lab-result-row__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.8rem;
  color: #1e293b;
}

.lab-result-row__head > div {
  display: grid;
  gap: 0.18rem;
}

.lab-result-row__group {
  color: #6366f1;
  font-size: 0.68rem;
  font-weight: 800;
}

.lab-result-row__unit {
  flex: 0 0 auto;
  color: #64748b;
  font-size: 0.76rem;
  font-weight: 750;
  white-space: nowrap;
}

.lab-result-row__value .soft-input {
  flex: 1 1 0;
  width: auto;
  min-width: 0;
}

.lab-result-row__body {
  display: grid;
  grid-template-columns: minmax(9rem, 0.75fr) minmax(18rem, 1.6fr);
  gap: 0.8rem;
}

.lab-classification {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.45rem;
}

.lab-classification .clinical-choice {
  min-height: 2.8rem;
  padding: 0.55rem 0.35rem;
  font-size: 0.76rem;
}

.lab-result-row__finding {
  grid-column: 1/-1;
}

@media (max-width: 767px) {
  .clinical-block {
    padding: 0.85rem;
    border-radius: 1rem;
  }
  .clinical-field-grid,
  .lab-result-row__body {
    grid-template-columns: minmax(0, 1fr);
  }
  .clinical-choice {
    min-height: 2.7rem;
    padding: 0.62rem 0.55rem;
    border-radius: 0.85rem;
    font-size: 0.78rem;
  }
  .lab-result-row {
    padding: 0.82rem;
    border-radius: 1rem;
  }
  .lab-classification {
    gap: 0.38rem;
  }
  .lab-classification .clinical-choice {
    min-height: 2.65rem;
    font-size: 0.7rem;
  }
}`],
})
export class ComponentSurveyRendererComponent implements OnInit, OnChanges {
    @Input() question: any;
    @Input() scales: any = {};
    @Input() answers: any = {};
    @Input() subject: any = {};
    @Input() readonly: boolean = false;
    @Output() change = new EventEmitter<any>();
    private timeDrafts: any = {};
    private clinicalNumberDrafts: any = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public ngOnChanges() {}

    public trackByIndex(index: number): number {
        return index;
    }

    private normalizeScaleOptions(options: any[]): any[] {
        if (!Array.isArray(options)) return [];
        return options.map((opt: any, index: number) => {
            if (opt && typeof opt === 'object' && !Array.isArray(opt)) {
                return {
                    ...opt,
                    label: opt.label ?? String(opt.value ?? index),
                    value: opt.value ?? index,
                };
            }
            return {
                label: String(opt),
                value: index,
            };
        });
    }

    private normalizeQuestionOptions(options: any[]): any[] {
        if (!Array.isArray(options)) return [];
        return options.map((opt: any, index: number) => {
            if (opt && typeof opt === 'object' && !Array.isArray(opt)) {
                return {
                    ...opt,
                    label: opt.label ?? String(opt.value ?? index),
                    value: opt.value ?? opt.label ?? index,
                };
            }
            return {
                label: String(opt),
                value: opt,
            };
        });
    }

    // 스케일 옵션 가져오기
    public scaleOptions(key: string): any[] {
        return this.normalizeScaleOptions((this.scales && this.scales[key]) ? this.scales[key] : []);
    }

    public questionOptions(question: any): any[] {
        if (!question) return [];
        if (Array.isArray(question.options) && question.options.length > 0) {
            return this.normalizeQuestionOptions(question.options);
        }
        if (question.scale) {
            return this.scaleOptions(question.scale);
        }
        return [];
    }

    public singlePresentation(question: any): string {
        const options = this.questionOptions(question);
        if (options.some((opt: any) => !!opt.image)) return 'image';
        if (options.some((opt: any) => !!opt.color)) return 'color';
        return 'default';
    }

    public optionImageSrc(option: any): string {
        if (!option || !option.image) return '';
        return encodeURI(String(option.image));
    }

    public hasValue(value: any): boolean {
        if (value === null || value === undefined) return false;
        if (typeof value === 'string') return value.trim().length > 0;
        if (Array.isArray(value)) return value.length > 0;
        if (typeof value === 'object') {
            const values = Object.values(value);
            if (values.length === 0) return false;
            return values.some((item: any) => this.hasValue(item));
        }
        return true;
    }

    public isCompactLikert(question: any): boolean {
        return !!question && question.type === 'scale' && ['csei5', 'pss5'].indexOf(question.scale) >= 0;
    }

    public selectedScaleLabel(question: any): string {
        if (!question || !question.scale) return '';
        const selected = this.scaleOptions(question.scale).find((opt: any) => opt.value === this.getVal(question.key));
        return selected ? selected.label : '';
    }

    public selectedOptionLabel(question: any): string {
        if (!question) return '';
        const selected = this.questionOptions(question).find((opt: any) => opt.value === this.getVal(question.key));
        return selected ? selected.label : '';
    }

    public firstScaleLabel(question: any): string {
        const options = question && question.scale ? this.scaleOptions(question.scale) : [];
        return options.length > 0 ? options[0].label : '';
    }

    public lastScaleLabel(question: any): string {
        const options = question && question.scale ? this.scaleOptions(question.scale) : [];
        return options.length > 0 ? options[options.length - 1].label : '';
    }

    public getVal(key: string): any {
        if (!this.answers) return undefined;
        return this.answers[key];
    }

    private pruneDependentAnswers(key: string, value: any) {
        if (!this.answers) return;
        const isEmpty = value === null || value === undefined || (typeof value === 'string' && value.trim().length === 0);
        if (key === 'psqi_5_j' && isEmpty) {
            this.answers['psqi_5_j1'] = null;
        }
    }

    public setVal(key: string, v: any) {
        if (!this.answers) this.answers = {};
        const previousValue = this.answers[key];
        this.answers[key] = v;
        this.change.emit({ key, value: v, previousValue });
        void this.service.render();
    }

    // ===== 단일 선택 (radio) =====
    public onSingle(key: string, v: any) {
        if (this.readonly) return;
        this.setVal(key, v);
    }

    // ===== 다중 선택 (checkbox) =====
    public onMulti(key: string, v: any, checked: boolean) {
        if (this.readonly) return;
        let cur: any[] = this.getVal(key) || [];
        if (!Array.isArray(cur)) cur = [];
        const idx = cur.indexOf(v);
        if (checked && idx < 0) cur = [...cur, v];
        if (!checked && idx >= 0) cur = cur.filter((x: any) => x !== v);
        this.setVal(key, cur);
    }

    public isMultiChecked(key: string, v: any): boolean {
        const cur = this.getVal(key);
        return Array.isArray(cur) && cur.indexOf(v) >= 0;
    }

    // ===== Yes/No =====
    public onYesNo(key: string, v: string) {
        if (this.readonly) return;
        this.setVal(key, v);
    }

    // ===== Number with unit =====
    public onNumber(key: string, e: any) {
        if (this.readonly) return;
        const v = e && e.target ? e.target.value : e;
        this.setVal(key, v === '' || v === null ? null : Number(v));
    }

    // ===== Text / Textarea =====
    public onText(key: string, e: any) {
        if (this.readonly) return;
        const v = e && e.target ? e.target.value : e;
        this.pruneDependentAnswers(key, v);
        this.setVal(key, v);
    }

    // ===== Time HH/MM =====
    public timePeriods(): any[] {
        return [
            { label: '오전', value: 'AM' },
            { label: '오후', value: 'PM' },
        ];
    }

    public timeHourOptions(): number[] {
        return Array.from({ length: 12 }, (_, index) => index + 1);
    }

    public timeMinuteOptions(): number[] {
        return Array.from({ length: 60 }, (_, index) => index);
    }

    private storedTimeDraft(key: string): any {
        const cur = this.getVal(key);
        if (!cur || typeof cur !== 'object' || Array.isArray(cur)) {
            return { period: '', hour12: '', minute: '' };
        }
        const hour = typeof cur.h === 'number' ? cur.h : null;
        const minute = typeof cur.m === 'number' ? cur.m : '';
        if (hour === null) {
            return { period: '', hour12: '', minute };
        }
        let hour12 = hour % 12;
        if (hour12 === 0) hour12 = 12;
        return {
            period: hour >= 12 ? 'PM' : 'AM',
            hour12,
            minute,
        };
    }

    private timeDraft(key: string): any {
        return {
            ...this.storedTimeDraft(key),
            ...(this.timeDrafts[key] || {}),
        };
    }

    private convertTo24Hour(period: string, hour12: number): number {
        if (period === 'AM') {
            return hour12 === 12 ? 0 : hour12;
        }
        return hour12 === 12 ? 12 : hour12 + 12;
    }

    private commitTimeDraft(key: string, patch: any = {}) {
        const draft = {
            ...this.timeDraft(key),
            ...patch,
        };
        this.timeDrafts[key] = draft;

        let cur = this.getVal(key) || {};
        if (typeof cur !== 'object' || Array.isArray(cur)) cur = {};

        cur.m = draft.minute === '' || draft.minute === null || draft.minute === undefined ? null : Number(draft.minute);
        if (draft.period && draft.hour12 !== '' && draft.hour12 !== null && draft.hour12 !== undefined) {
            cur.h = this.convertTo24Hour(String(draft.period), Number(draft.hour12));
        } else {
            cur.h = null;
        }
        this.setVal(key, cur);
    }

    public onTimePeriodSelect(key: string, e: any) {
        if (this.readonly) return;
        const value = e && e.target ? e.target.value : e;
        this.commitTimeDraft(key, { period: value || '' });
    }

    public onTimeHourSelect(key: string, e: any) {
        if (this.readonly) return;
        const value = e && e.target ? e.target.value : e;
        this.commitTimeDraft(key, { hour12: value === '' || value === null ? '' : Number(value) });
    }

    public onTimeMinuteSelect(key: string, e: any) {
        if (this.readonly) return;
        const value = e && e.target ? e.target.value : e;
        this.commitTimeDraft(key, { minute: value === '' || value === null ? '' : Number(value) });
    }

    public getTimePeriod(key: string): any {
        return this.timeDraft(key).period || '';
    }

    public getTimeHour12(key: string): any {
        const hour12 = this.timeDraft(key).hour12;
        return hour12 === null || hour12 === undefined ? '' : hour12;
    }

    public onTimePart(key: string, part: 'h' | 'm', e: any) {
        if (this.readonly) return;
        const v = e && e.target ? e.target.value : e;
        let cur = this.getVal(key) || {};
        if (typeof cur !== 'object' || Array.isArray(cur)) cur = {};
        cur[part] = v === '' ? null : Number(v);
        this.setVal(key, cur);
    }

    public getTimePart(key: string, part: 'h' | 'm'): any {
        const cur = this.getVal(key);
        if (!cur || typeof cur !== 'object') return '';
        const v = cur[part];
        return (v === null || v === undefined) ? '' : v;
    }

    public timeLabel(value: any): string {
        const num = Number(value);
        if (Number.isNaN(num)) return '';
        return String(num).padStart(2, '0');
    }

    // ===== Duration HH/MM =====
    public onDurationPart(key: string, part: 'h' | 'm', e: any) {
        this.onTimePart(key, part, e);
    }
    public getDurationPart(key: string, part: 'h' | 'm'): any {
        return this.getTimePart(key, part);
    }

    // ===== Body map =====
    public onBodyPart(key: string, opt: any, checked: boolean) {
        this.onMulti(key, opt, checked);
    }

    public isBodyChecked(key: string, opt: any): boolean {
        return this.isMultiChecked(key, opt);
    }

    // ===== Table matrix (PSQI 5a-i) =====
    public onTableCell(key: string, rowKey: string, v: any) {
        if (this.readonly) return;
        let cur = this.getVal(key) || {};
        if (typeof cur !== 'object' || Array.isArray(cur)) cur = {};
        cur[rowKey] = v;
        this.setVal(key, cur);
    }

    public getTableCell(key: string, rowKey: string): any {
        const cur = this.getVal(key);
        if (!cur || typeof cur !== 'object') return null;
        return cur[rowKey];
    }

    // ===== 관리자 임상 기록 공통 패널 =====
    private objectValue(key: string): any {
        const value = this.getVal(key);
        if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
        return value;
    }

    private conditionMatches(value: any, condition: any): boolean {
        if (!condition) return true;
        const current = condition.key ? value?.[condition.key] : undefined;
        if (condition.eq !== undefined) return current === condition.eq;
        if (condition.ne !== undefined) return current !== condition.ne;
        if (Array.isArray(condition.in)) return condition.in.indexOf(current) >= 0;
        if (Array.isArray(condition.notIn)) return condition.notIn.indexOf(current) < 0;
        return true;
    }

    public inlineOptions(options: any[]): any[] {
        return this.normalizeQuestionOptions(options || []);
    }

    public getClinicalField(key: string, field: string): any {
        const value = this.objectValue(key)[field];
        return value === null || value === undefined ? '' : value;
    }

    public onClinicalField(key: string, field: any, event: any) {
        if (this.readonly || !field?.key) return;
        const raw = event && event.target ? event.target.value : event;
        let value: any = raw;
        if (field.type === 'number') {
            value = raw === '' || raw === null || raw === undefined ? null : Number(raw);
        }
        this.setVal(key, {
            ...this.objectValue(key),
            [field.key]: value,
        });
    }

    private clinicalNumberDraftKey(key: string, fieldKey: string): string {
        return `${key}:${fieldKey}`;
    }

    public clinicalNumberPlaceholder(field: any): string {
        const decimals = Number(field?.decimals);
        if (!Number.isInteger(decimals) || decimals <= 0) return '';
        return `0.${'0'.repeat(decimals)}`;
    }

    public clinicalNumberValue(key: string, field: any): any {
        if (!field?.key) return '';
        const draftKey = this.clinicalNumberDraftKey(key, field.key);
        if (Object.prototype.hasOwnProperty.call(this.clinicalNumberDrafts, draftKey)) {
            return this.clinicalNumberDrafts[draftKey];
        }

        const value = this.getClinicalField(key, field.key);
        if (value === '') return '';
        const decimals = Number(field.decimals);
        if (Number.isInteger(decimals) && decimals >= 0 && Number.isFinite(Number(value))) {
            return Number(value).toFixed(decimals);
        }
        return value;
    }

    public onClinicalNumberInput(key: string, field: any, event: any) {
        if (this.readonly || !field?.key) return;
        const raw = event && event.target ? event.target.value : event;
        const draftKey = this.clinicalNumberDraftKey(key, field.key);
        this.clinicalNumberDrafts[draftKey] = raw;

        const numericValue = raw === '' || raw === null || raw === undefined
            ? null
            : Number(raw);
        if (numericValue !== null && !Number.isFinite(numericValue)) return;
        this.setVal(key, {
            ...this.objectValue(key),
            [field.key]: numericValue,
        });
    }

    public onClinicalNumberBlur(key: string, field: any, event: any) {
        if (this.readonly || !field?.key) return;
        const draftKey = this.clinicalNumberDraftKey(key, field.key);
        const eventValue = event && event.target ? event.target.value : event;
        const raw = Object.prototype.hasOwnProperty.call(this.clinicalNumberDrafts, draftKey)
            ? this.clinicalNumberDrafts[draftKey]
            : eventValue;

        if (raw === '' || raw === null || raw === undefined) {
            this.clinicalNumberDrafts[draftKey] = '';
            this.setVal(key, {
                ...this.objectValue(key),
                [field.key]: null,
            });
            return;
        }

        const parsed = Number(raw);
        if (!Number.isFinite(parsed)) return;
        const decimals = Number(field.decimals);
        const normalized = Number.isInteger(decimals) && decimals >= 0
            ? Number(parsed.toFixed(decimals))
            : parsed;
        this.clinicalNumberDrafts[draftKey] =
            Number.isInteger(decimals) && decimals >= 0
                ? normalized.toFixed(decimals)
                : String(normalized);
        this.setVal(key, {
            ...this.objectValue(key),
            [field.key]: normalized,
        });
    }

    public onClinicalChoice(key: string, fieldKey: string, value: any) {
        if (this.readonly || !fieldKey) return;
        this.setVal(key, {
            ...this.objectValue(key),
            [fieldKey]: value,
        });
    }

    public clinicalGroupVisible(key: string, group: any): boolean {
        return this.conditionMatches(this.objectValue(key), group?.showIf);
    }

    public clinicalFieldVisible(key: string, field: any): boolean {
        return this.conditionMatches(this.objectValue(key), field?.showIf);
    }

    public clinicalReasonVisible(key: string, reason: any): boolean {
        return !!reason && this.conditionMatches(this.objectValue(key), reason.showIf);
    }

    public onClinicalReason(key: string, reason: any, event: any) {
        this.onClinicalField(key, { key: reason?.key, type: 'text' }, event);
    }

    // ===== 관리자 실험실 검사 표 =====
    public visibleLabRows(question: any): any[] {
        const gender = this.subject?.gender || 'O';
        const rows = Array.isArray(question?.rows) ? question.rows : [];
        return rows.filter((row: any) =>
            !row?.gender || gender === 'O' || row.gender === gender
        );
    }

    public getLabField(key: string, field: string): any {
        return this.getClinicalField(key, field);
    }

    public onLabField(key: string, field: string, event: any) {
        if (this.readonly || !field) return;
        const raw = event && event.target ? event.target.value : event;
        this.setVal(key, {
            ...this.objectValue(key),
            [field]: raw,
        });
    }

    public getLabRowField(key: string, rowKey: string, field: string): any {
        const results = this.objectValue(key).results;
        if (!results || typeof results !== 'object' || Array.isArray(results)) return '';
        const row = results[rowKey];
        if (!row || typeof row !== 'object' || Array.isArray(row)) return '';
        const value = row[field];
        return value === null || value === undefined ? '' : value;
    }

    public onLabRowField(key: string, rowKey: string, field: string, event: any) {
        if (this.readonly || !rowKey || !field) return;
        const raw = event && event.target ? event.target.value : event;
        const root = this.objectValue(key);
        const results = root.results && typeof root.results === 'object' && !Array.isArray(root.results)
            ? root.results
            : {};
        const row = results[rowKey] && typeof results[rowKey] === 'object' && !Array.isArray(results[rowKey])
            ? results[rowKey]
            : {};
        this.setVal(key, {
            ...root,
            results: {
                ...results,
                [rowKey]: {
                    ...row,
                    [field]: raw,
                },
            },
        });
    }

    // ===== Obstetric (산과력) =====
    public onObstetricField(key: string, field: string, e: any) {
        if (this.readonly) return;
        const v = e && e.target ? e.target.value : e;
        let cur = this.getVal(key) || {};
        if (typeof cur !== 'object' || Array.isArray(cur)) cur = {};
        cur[field] = v === '' || v === null ? null : Number(v);
        this.setVal(key, cur);
    }

    public getObstetricField(key: string, field: string): any {
        const cur = this.getVal(key);
        if (!cur || typeof cur !== 'object') return '';
        const v = cur[field];
        return (v === null || v === undefined) ? '' : v;
    }

    // ===== Smoke detail =====
    public onSmokeField(key: string, field: string, e: any) {
        if (this.readonly) return;
        const v = e && e.target ? e.target.value : e;
        let cur = this.getVal(key) || {};
        if (typeof cur !== 'object' || Array.isArray(cur)) cur = {};
        cur[field] = v === '' || v === null ? null : Number(v);
        this.setVal(key, cur);
    }

    public getSmokeField(key: string, field: string): any {
        const cur = this.getVal(key);
        if (!cur || typeof cur !== 'object') return '';
        const v = cur[field];
        return (v === null || v === undefined) ? '' : v;
    }

    // ===== Drink row =====
    private blankDrinkRow(): any {
        return {
            type: '',
            amount: null,
            unit: '',
            count: null,
        };
    }

    private normalizeDrinkRows(value: any): any[] {
        if (Array.isArray(value)) {
            return value.filter((row: any) => row && typeof row === 'object' && !Array.isArray(row));
        }
        if (value && typeof value === 'object') {
            return [value];
        }
        return [];
    }

    public drinkRows(key: string): any[] {
        const rows = this.normalizeDrinkRows(this.getVal(key));
        return rows.length > 0 ? rows : [this.blankDrinkRow()];
    }

    public addDrinkRow(key: string) {
        if (this.readonly) return;
        const rows = this.normalizeDrinkRows(this.getVal(key));
        this.setVal(key, [...rows, this.blankDrinkRow()]);
    }

    public removeDrinkRow(key: string, index: number) {
        if (this.readonly) return;
        const rows = this.normalizeDrinkRows(this.getVal(key));
        if (rows.length <= 1) return;
        this.setVal(key, rows.filter((_: any, rowIndex: number) => rowIndex !== index));
    }

    public canRemoveDrinkRow(key: string): boolean {
        return this.normalizeDrinkRows(this.getVal(key)).length > 1;
    }

    public onDrinkField(key: string, index: number, field: string, e: any) {
        if (this.readonly) return;
        const v = e && e.target ? e.target.value : e;
        const rows = this.normalizeDrinkRows(this.getVal(key));
        while (rows.length <= index) {
            rows.push(this.blankDrinkRow());
        }
        const cur = rows[index] || this.blankDrinkRow();
        if (field === 'amount' || field === 'count') {
            cur[field] = v === '' || v === null ? null : Number(v);
        } else {
            cur[field] = v;
        }
        rows[index] = cur;
        this.setVal(key, rows);
    }

    public getDrinkField(key: string, index: number, field: string): any {
        const rows = this.normalizeDrinkRows(this.getVal(key));
        const cur = rows[index];
        if (!cur || typeof cur !== 'object') return '';
        const v = cur[field];
        return (v === null || v === undefined) ? '' : v;
    }

    public drinkCountOptions(): number[] {
        return [1, 2, 3, 4, 5, 6, 7];
    }

    public isDrinkCountSelected(key: string, index: number, count: number): boolean {
        return Number(this.getDrinkField(key, index, 'count')) === count;
    }
}

export default ComponentSurveyRendererComponent;